import {
  KeyboardDatePicker, MuiPickersUtilsProvider
} from '@material-ui/pickers';
import MaterialTable from 'material-table';
import React from 'react';
import { connect } from "react-redux";
import { UiActions } from 'state/actions/UiActions';
import { InfluencerPaymentActions } from 'state/actions/user/InfluencerPaymentActions';
import { tableIcons } from '../../components/admin/TableIcons';
import DateFnsUtils from '@date-io/date-fns';
import { Helmet } from 'react-helmet';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';

class InfluencerPayment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      payments: [],
      showValoresQuebrados: false,
      startDate: null,
      dateFromRequest: null,
      syncGlamshop: false
    }
  }

  componentDidMount() {
    const {
      history,
      person
    } = this.props;

    this.props.isAdmin(
      person.person.username,
      (response) => {
        const isAdmin = response.result;
        if (!isAdmin) {
          history.push("/");
        }
      });
  }

  renderDatePickers = () => {
    let { startDate } = this.state;
    return (
      <div>

        <h3 className={"display-3"}>
          Selecione um período
        </h3>

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            disableToolbar
            format="dd/MM/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="Data início"
            value={startDate}
            onChange={this.updateStartDate}
            autoOk={true}
            okLabel={""}
            openTo="year"
            views={["year", "month"]}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </MuiPickersUtilsProvider>
        <div style={{maxWidth: '35%', margin: '1em'}}>
          <input style={{ transform: 'scale(2)'}}
            type={"checkbox"}
            checked={this.state.syncGlamshop}
            onChange={this.toggleSyncGlamshop} />

          <label style={{ margin: '1em'}}>
            Atualiza Glamshop  <small>(Essa atualização pode levar um tempo!
            Verifique se precisa mesmo dela, pois já foi feita no 1o dia no mês)</small>
          </label>
        </div>
        <div className={"mb-2"}>
          <button onClick={this.getPayments}
            className={"btn btn-light-lime"}>
            Buscar
        </button>
        </div>
      </div>

    );
  }

  toggleSyncGlamshop = () => {
    this.setState({
      syncGlamshop: !this.state.syncGlamshop
    });
  };

  updateStartDate = (date) => {
    let startDate = new Date(date);
    let month = (startDate.getMonth() + 1);
    let convertedDate = startDate.getFullYear() + "/" + month + "/" + startDate.getDate();

    this.setState({
      startDate: date,
      dateFromRequest: convertedDate
    });
  }

  getPayments = () => {
    const { syncGlamshop } = this.state;
    if (syncGlamshop) {
      this.syncGlamshopCouponUsage((callback) => {
        this.payments();
      });
    } else {
      this.payments();
    }


  }

  payments = () => {
    const { dateFromRequest } = this.state;
    if (!dateFromRequest) return null;

    this.props.loaderShow();
    this.props.getPayments(dateFromRequest,
      (response) => {

        let {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          this.setState({
            payments: result.payment
          });
        }

        this.props.loaderHide();
      });
  }

  syncGlamshopCouponUsage = (callback) => {
    const { startDate } = this.state;
    let month = (startDate.getMonth() + 1).toLocaleString("pt-BR");
    let day = 1;
    let year = startDate.getFullYear();

    let dateFrom = `${month}/${day}/${year}`;

    this.props.loaderShow();
    fetch(
      process.env.REACT_APP_GB_API_ROOT + GlamboxEndpoints.Glamshop.syncCouponUsage.url + "?dateFrom=" + dateFrom,
      {
        method: 'POST',
        headers: { 'Authorization': this.props.token },
      }
    ).then(response => {
      this.props.loaderHide();
      callback();
    })

  }

  getHeaders = () => {
    let headers = [
      { title: 'PersonId', field: 'personId', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Nome', field: 'name', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Documento', field: 'document', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Favorecido', field: 'accountHolder', editable: 'never', hiddenByColumnsButton: true },
      { title: 'PIS', field: 'pis', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Emite NF?', field: 'issueInvoice', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Cód. banco', field: 'bankCode', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Nome banco', field: 'bankName', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Agência', field: 'agency', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Dígito Agência', field: 'agencyDigit', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Conta', field: 'account', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Dígito Conta', field: 'accountDigit', editable: 'never', hiddenByColumnsButton: true },
      { title: 'PIX', field: 'pix', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Tipo PIX', field: 'pixType', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Período', field: 'period', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Vendas Glambox', field: 'glamboxPayment', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Vendas Glamshop', field: 'glamshopPayment', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Vendas B4A', field: 'b4APayment', editable: 'never', hiddenByColumnsButton: true },
      {
        title: 'Status do pagamento', field: 'paymentStatus', editComponent: props => {
          const options = ['New', 'Unpaid', 'Cancelled', 'Denied',
            'Dunning', 'Paid', 'Pending', 'Validation Pending', 'Error', 'Closed'];
          return (
            this.renderStatusOptions(props, options)
          )
        }
      },
      { title: 'Saldo devedor', field: 'saldoDevedor', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Total a pagar', field: 'totalToPay', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Valor adicional', field: 'aditionalValue', hiddenByColumnsButton: true },
      { title: 'Total Pago', field: 'totalPaid', editable: 'never', hiddenByColumnsButton: true },
      { title: 'UpdateUser', field: 'userUpdate', editable: 'never', editable: 'never', hiddenByColumnsButton: true },
      {
        title: 'Reason', field: 'reason', hiddenByColumnsButton: true
        // ,editComponent: props =>{
        //   return(
        //     this.renderReason(props.value)
        //   )
        // }}
      }
    ]

    return headers;
  }

  renderStatusOptions = (props, options) => {
    return (
      <select onChange={(e) => props.onChange(e.target.value)}
        value={props.value}>
        {(() => {
          return options.map((value, key) => {
            return (
              <option value={value} key={key}>
                {value}
              </option>
            );
          });
        })()}
      </select>);
  }

  renderReason = (reason) => {
    console.log(reason)
    return (
      <textarea>
        {reason}
      </textarea>
    )
  }

  updateData = async (payload, callback) => {
    await this.props.updatePayments(payload);
    callback();
  }

  updateBulk = (changes, callback) => {
    for (let n in changes) {
      let newData = changes[n].newData;
      let oldData = changes[n].oldData;

      const payload = this.getdUpdatePayload(newData, oldData);
      this.updateData(payload, callback);
    }
  }

  getdUpdatePayload = (newData, oldData) => {
    console.log(newData)
    let totalPaid = parseFloat(newData.totalToPay) + parseFloat(newData.aditionalValue);
    let payload = {
      document: oldData.document,
      period: oldData.period,
      paymentStatus: (newData.paymentStatus !== null ? newData.paymentStatus : 'Pending'),
      personId: oldData.personId,
      aditionalValue: parseFloat(newData.aditionalValue),
      totalPaid: totalPaid,
      reason: newData.reason
    }

    return payload;
  }

  renderPayments = () => {
    const { payments } = this.state;

    if (payments.length === 0) {
      return null;
    }

    let editable = {
      onRowUpdate: (newData, oldData) => {
        return new Promise((resolve, reject) => {
          let dataUpdate = [...payments];

          for (const n in dataUpdate) {
            if (dataUpdate[n].personId === newData.personId) {
              dataUpdate[n] = Object.assign({}, dataUpdate[n], newData);
            }
          }

          const payload = this.getdUpdatePayload(newData, oldData);

          this.updateData(payload, () => {
            this.setState({
              payments: dataUpdate
            });
            resolve();
          });
        });
      },
      onBulkUpdate: (changes) => {
        return new Promise((resolve, reject) => {
          this.updateBulk(changes, (response) => {
            resolve();
          });
        });
      }
    }

    return (
      <>

        <MaterialTable
          columns={this.getHeaders()}
          data={payments}
          title="Influencer Payments"
          editable={editable}
          options={{
            filtering: true,
            columnsButton: true,
            exportButton: true,
            exportAllData: true,
            actionsColumnIndex: -1
          }}
          icons={tableIcons}

        />
      </>
    )
  }


  render() {

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Admin Influencers : Influencers Payments</title>
        </Helmet>

        <h1>Influencers Payments</h1>

        {this.renderDatePickers()}
        {this.renderPayments()}

      </div>
    );
  }


}

const mapStateToProps = (state) => ({
  store: state,
  person: state.person.data,
  partnerGeneral: state.partnerGeneral.data,
  token: state.token.data.Authorization

});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  getPayments: (dateFrom, callback) => {
    dispatch(InfluencerPaymentActions.get(dateFrom, callback));
  },
  updatePayments: (payload, callback) => {
    dispatch(InfluencerPaymentActions.update(payload, callback));
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  }
});

InfluencerPayment = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfluencerPayment);

export {
  InfluencerPayment
};
